import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice d'inflation - Pouvoir d'achat et Valeur réelle";
const DESCRIPTION =
  "Calculatrice d'inflation - Pouvoir d'achat et Valeur réelle. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "d inflation pouvoir d achat valeur réelle, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/inflation-calculator/";
function InflationCalculator() {
  const [initialAmount, setInitialAmount] = useState("");
  const [inflationRate, setInflationRate] = useState("");
  const [numberOfYears, setNumberOfYears] = useState("");
  const [inflation, setInflation] = useState(null);
  const [error, setError] = useState("");

  const handleReset = () => {
    setInitialAmount("");
    setInflationRate("");
    setNumberOfYears("");
    setInflation(null);
    setError("");
  };

  const handleCalculate = () => {
    try {
      if (!initialAmount || !inflationRate || !numberOfYears) {
        setError("Veuillez entrer tous les paramètres obligatoires");
        setInflation(null);
        return;
      }
      const amount = parseFloat(initialAmount);
      const rate = parseFloat(inflationRate);
      const years = parseFloat(numberOfYears);

      if (amount <= 0) {
        setError("Le montant initial doit être positif");
        setInflation(null);
        return;
      }
      if (rate < 0) {
        setError("Le taux d'inflation ne peut pas être négatif");
        setInflation(null);
        return;
      }
      if (years <= 0) {
        setError("Le nombre d'années doit être positif");
        setInflation(null);
        return;
      }

      // Calcul: Valeur future (nominal) = montant initial * (1 + taux d'inflation)^années
      const futureNominalValue = amount * Math.pow(1 + rate / 100, years);
      
      // Pouvoir d'achat réel = montant initial / (1 + taux d'inflation)^années
      const realPurchasingPower = amount / Math.pow(1 + rate / 100, years);
      
      // Perte de pouvoir d'achat
      const purchasingPowerLoss = amount - realPurchasingPower;
      const purchasingPowerLossPercentage = (purchasingPowerLoss / amount) * 100;

      // Montant nominal équivalent nécessaire pour maintenir le pouvoir d'achat
      const nominalAmountNeeded = futureNominalValue;

      setInflation({
        initialAmount: amount.toFixed(2),
        inflationRate: rate.toFixed(2),
        years: years.toFixed(2),
        futureNominalValue: futureNominalValue.toFixed(2),
        realPurchasingPower: realPurchasingPower.toFixed(2),
        purchasingPowerLoss: purchasingPowerLoss.toFixed(2),
        purchasingPowerLossPercentage: purchasingPowerLossPercentage.toFixed(2),
        nominalAmountNeeded: nominalAmountNeeded.toFixed(2)
      });
      setError("");
    } catch (err) {
      setError("Une erreur s'est produite lors du calcul");
      setInflation(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  L'inflation est l'augmentation continue du niveau général des prix des biens et services. 
                  Cette calculatrice vous aide à comprendre comment l'inflation affecte le pouvoir d'achat 
                  de votre argent au fil du temps. Elle montre combien de valeur votre argent perd réellement 
                  due à l'inflation, et combien vous devriez avoir économisé pour maintenir le même pouvoir d'achat.
                </p>
                <hr />
                <h3 style={{ fontSize: "16px", color: "#28a745" }}>Formules:</h3>
                <p style={{ backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
                  Valeur future nominale = Montant initial × (1 + Taux inflation)^Années<br/>
                  Pouvoir d'achat réel = Montant initial ÷ (1 + Taux inflation)^Années<br/>
                  Perte de pouvoir d'achat = Montant initial - Pouvoir d'achat réel
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <hr />
                  <div className="form-group">
                    <label className="form-label fw-bold">Montant initial (€)</label>
                    <input
                      type="number"
                      value={initialAmount}
                      onChange={(e) => setInitialAmount(e.target.value)}
                      placeholder="Ex: 10000"
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                    <small className="text-muted">La quantité d'argent que vous avez aujourd'hui</small>
                  </div>
                  <br />
                  <div className="form-group">
                    <label className="form-label fw-bold">Taux d'inflation annuel moyen (%)</label>
                    <input
                      type="number"
                      value={inflationRate}
                      onChange={(e) => setInflationRate(e.target.value)}
                      placeholder="Ex: 2.5"
                      className="form-control"
                      step="0.1"
                      style={{ width: "90%" }}
                    />
                    <small className="text-muted">Taux d'inflation annuel (ex: 2.5% pour une inflation de 2.5% par an)</small>
                  </div>
                  <br />
                  <div className="form-group">
                    <label className="form-label fw-bold">Nombre d'années</label>
                    <input
                      type="number"
                      value={numberOfYears}
                      onChange={(e) => setNumberOfYears(e.target.value)}
                      placeholder="Ex: 10"
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                    <small className="text-muted">Période considérée en années</small>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "16px", marginRight: "10px" }}
                    onClick={handleCalculate}
                  >
                    Calculer l'impact inflation
                  </button>
                  <button
                    className="btn btn-secondary"
                    style={{ fontSize: "16px" }}
                    onClick={handleReset}
                  >
                    Réinitialiser
                  </button>
                  <br />
                  <br />
                  {error && (
                    <p className="p-3 mb-2 bg-warning text-black border-left border-warning">
                      <strong>Erreur:</strong> {error}
                    </p>
                  )}
                  {inflation && (
                    <div className="p-3 mb-2 bg-success text-white" style={{ borderRadius: "5px" }}>
                      <h4>Analyse de l'impact inflation:</h4>
                      <table className="table table-sm table-dark" style={{ marginTop: "15px" }}>
                        <tbody>
                          <tr>
                            <td><strong>Montant initial:</strong></td>
                            <td style={{ color: "#90EE90", fontSize: "16px" }}>{inflation.initialAmount}€</td>
                          </tr>
                          <tr>
                            <td><strong>Période:</strong></td>
                            <td style={{ color: "#87CEEB", fontSize: "16px" }}>{inflation.years} ans</td>
                          </tr>
                          <tr>
                            <td><strong>Taux d'inflation annuel:</strong></td>
                            <td style={{ color: "#FFA07A", fontSize: "16px" }}>{inflation.inflationRate}%</td>
                          </tr>
                          <tr style={{ backgroundColor: "#333333" }}>
                            <td><strong style={{ color: "#FFD700" }}>💰 Pouvoir d'achat réel:</strong></td>
                            <td style={{ color: "#FFD700", fontSize: "18px", fontWeight: "bold" }}>{inflation.realPurchasingPower}€</td>
                          </tr>
                          <tr>
                            <td><strong>Perte de pouvoir d'achat:</strong></td>
                            <td style={{ color: "#FF6B6B", fontSize: "16px" }}>{inflation.purchasingPowerLoss}€ ({inflation.purchasingPowerLossPercentage}%)</td>
                          </tr>
                          <tr style={{ backgroundColor: "#333333" }}>
                            <td><strong style={{ color: "#90EE90" }}>📈 Montant à épargner aujourd'hui:</strong></td>
                            <td style={{ color: "#90EE90", fontSize: "18px", fontWeight: "bold" }}>{inflation.nominalAmountNeeded}€</td>
                          </tr>
                        </tbody>
                      </table>
                      <p style={{ marginTop: "15px", fontSize: "14px" }}>
                        <em>Pour conserver le même pouvoir d'achat dans {inflation.years} ans, vous auriez besoin de {inflation.nominalAmountNeeded}€</em>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="info-sections-container">
              <div className="info-section">
                <h3>Qu'est-ce que l'inflation?</h3>
                <p>
                  L'inflation est l'augmentation générale et progressive des prix des biens et services 
                  dans une économie. Elle signifie que chaque euro a moins de pouvoir d'achat qu'avant. 
                  Par exemple, avec une inflation de 3% par an, l'argent que vous avez aujourd'hui ne pourra 
                  acheter que 97% de ce qu'il pouvait acheter l'année précédente.
                </p>
                <p>
                  L'inflation est un phénomène économique normal et peut être causée par plusieurs facteurs:
                </p>
                <ul>
                  <li><strong>Augmentation de la demande:</strong> Plus de demande que d'offre pousse les prix à la hausse</li>
                  <li><strong>Augmentation des coûts de production:</strong> Frais plus élevés de matières premières ou de main-d'œuvre</li>
                  <li><strong>Expansion monétaire:</strong> Augmentation de la masse monétaire en circulation</li>
                  <li><strong>Chocs externes:</strong> Crises, guerres, ou perturbations d'approvisionnement</li>
                </ul>
              </div>
              <div className="info-section">
                <h3>Comment l'inflation affecte votre pouvoir d'achat?</h3>
                <p>
                  Le pouvoir d'achat est la quantité de biens ou de services que vous pouvez acheter avec une 
                  certaine somme d'argent. Avec une inflation constante, votre argent perd de la valeur au fil du temps.
                </p>
                <p>
                  <strong>Exemple concret:</strong> Si vous avez 10 000€ et que l'inflation est de 3% par an:
                </p>
                <ul>
                  <li><strong>Année 0:</strong> Vos 10 000€ valent 10 000€ de pouvoir d'achat</li>
                  <li><strong>Année 1:</strong> Vos 10 000€ valent l'équivalent de 9 709€ de pouvoir d'achat</li>
                  <li><strong>Année 5:</strong> Vos 10 000€ valent l'équivalent de 8 626€ de pouvoir d'achat</li>
                  <li><strong>Année 10:</strong> Vos 10 000€ valent l'équivalent de 7 441€ de pouvoir d'achat</li>
                </ul>
                <p>
                  Cela signifie que si vous gardez vos 10 000€ sans les investir, vous perdez progressivement 
                  la capacité à acheter la même quantité de biens.
                </p>
              </div>
              <div className="info-section">
                <h3>Taux d'inflation par pays et perspective historique</h3>
                <p>
                  Le taux d'inflation varie considérablement selon les pays et les périodes:
                </p>
                <ul>
                  <li><strong>Zone euro (moyenne historique):</strong> 1.5% - 2% par an</li>
                  <li><strong>Avant 2020:</strong> Inflation faible et stable, généralement autour de 1-2%</li>
                  <li><strong>2021-2023:</strong> Inflation élevée (jusqu'à 10% en Zone euro), liée aux chocs post-COVID</li>
                  <li><strong>Inflation hyperélevée:</strong> Certains pays ont connu des taux à trois ou quatre chiffres</li>
                </ul>
                <p>
                  Pour les calculs de long terme (10+ ans), une hypothèse conservatrice de 2-3% d'inflation annuelle 
                  est généralement utilisée pour les pays développés.
                </p>
              </div>
              <div className="info-section">
                <h3>Comment se protéger contre l'inflation?</h3>
                <p>
                  Il existe plusieurs stratégies pour préserver votre capital face à l'inflation:
                </p>
                <ul>
                  <li><strong>Investissements en actions:</strong> Les marchés actions ont historiquement surpassé l'inflation</li>
                  <li><strong>Immobilier:</strong> Les prix immobiliers suivent généralement l'inflation</li>
                  <li><strong>Obligations indexées sur l'inflation:</strong> Les rendements augmentent avec l'inflation</li>
                  <li><strong>Or et matières premières:</strong> Traditionnellement considérés comme des couvertures d'inflation</li>
                  <li><strong>Épargne/Placements rémunérés:</strong> Chercher des taux d'intérêt supérieurs à l'inflation</li>
                  <li><strong>Cryptomonnaies:</strong> Option alternative mais très volatile</li>
                </ul>
                <p>
                  La stratégie idéale dépend de votre situation financière, votre horizon d'investissement, 
                  et votre tolérance au risque.
                </p>
              </div>
              <div className="info-section">
                <h3>Questions fréquemment posées sur l'inflation</h3>
                <p>
                  <strong>Q: L'inflation est-elle toujours mauvaise?</strong><br/>
                  R: Une inflation modérée (2-3%) est considérée comme saine pour une économie. Elle encourage 
                  la dépense et l'investissement plutôt que l'accumulation de cash. Une inflation très élevée 
                  ou une déflation (baisse des prix) sont problématiques.
                </p>
                <p>
                  <strong>Q: Comment la Banque Centrale contrôle-t-elle l'inflation?</strong><br/>
                  R: La BCE (Banque Centrale Européenne) contrôle l'inflation principalement en ajustant les taux 
                  d'intérêt directeurs. Des taux plus élevés découragent l'emprunt et ralentit la croissance, 
                  donc l'inflation. Des taux plus bas encouragent l'emprunt et stimule l'inflation.
                </p>
                <p>
                  <strong>Q: La stagflation, qu'est-ce que c'est?</strong><br/>
                  R: La stagflation est une situation rare mais difficile où l'inflation et le chômage augmentent 
                  simultanément, tandis que la croissance économique stagne. C'est particulièrement problématique 
                  car les politiques classiques pour lutter contre l'inflation aggravent le chômage.
                </p>
                <p>
                  <strong>Q: L'inflation 2021-2022 va-t-elle se reproduire?</strong><br/>
                  R: L'inflation extrêmement élevée de 2021-2023 a été un phénomène exceptionnel lié aux chocs 
                  de la pandémie. Les économistes s'attendent à un retour à une inflation plus stable et modérée, 
                  bien que l'incertitude demeure toujours.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default InflationCalculator;
